import React, { useCallback, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { object, oneOf, string, func } from 'prop-types';
import classNames from 'classnames/bind';
import { Accordion } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

import SearchAccordionItem from 'components/SearchAccordionItem';
import SearchByRef from 'components/SearchByRef';
import SearchByCar from 'components/SearchByCar';
import SearchByVin from 'components/SearchByVin';
import SearchByKba from 'components/SearchByKba';

import { withLabels } from 'containers/withLabels';

import { currentLanguage } from 'utils/currentLanguage';

import CarIcon from 'media/icons/vehicule-model.icon.svg';
import VinIcon from 'media/icons/vehicule-vin.icon.svg';
import ReferenceIcon from 'media/icons/vehicule-reference.icon.svg';

import styles from './SearchAccordion.module.scss';
const cx = classNames.bind(styles);

const SearchAccordion = (props) => {
  const {
    setRefData,
    setRefNoResults,
    getArticlesIds,
    resetSearchResults,
    createTabChangeAction,
    pageType,
    labels,
    selectedTabId,
  } = props;
  const { defaultSearchTab, location: { hash } } = window;
  const isGermanSite = currentLanguage === 'de';
  const isBrazilSite = currentLanguage === 'pt-br';
  const scrollRef = useRef();

  const handleChange = useCallback((...params) => {
    createTabChangeAction(...params);
    scrollRef && scrollRef.current && scrollRef.current.scrollIntoView();
  }, []);

  if (isBrazilSite) {
    return (
      <div ref={scrollRef}>
        <Accordion
          preExpanded={[
            hash.replace('#', '') || defaultSearchTab || selectedTabId,
          ]}
          onChange={handleChange}
          className={cx('accordion')}
        >
          <SearchAccordionItem
            uuid="reference"
            label={labels.searchReferenceTabTitle}
            Icon={
              <span className={cx('tab-icon')}>
                <ReferenceIcon />
              </span>
            }
            Panel={
              <SearchByRef
                pageType={pageType}
                setRefData={setRefData}
                setRefNoResults={setRefNoResults}
              />
            }
          />
        </Accordion>
      </div>
    );
  }

  return (
    <div ref={scrollRef}>
      <Accordion
        preExpanded={[
          hash.replace('#', '') || defaultSearchTab || selectedTabId,
        ]}
        onChange={handleChange}
        className={cx('accordion')}
      >
        <SearchAccordionItem
          uuid="car"
          label={labels.searchCarTabTitle}
          Icon={
            <span className={cx('tab-icon', 'icon-car')}>
              <CarIcon />
            </span>
          }
          Panel={
            <SearchByCar
              resetSearchResults={resetSearchResults}
              getArticlesIds={getArticlesIds}
              pageType={pageType}
            />
          }
        />
        {isGermanSite ? (
          <SearchAccordionItem
            uuid="kba"
            label={labels.searchKbaTabTitle}
            Icon={
              <span className={cx('tab-icon')}>
                <VinIcon />
              </span>
            }
            Panel={
              <SearchByKba getArticlesIds={getArticlesIds} pageType={pageType} />
            }
          />
        ) : (
          <SearchAccordionItem
            uuid="vin"
            label={labels.searchVinTabTitle}
            Icon={
              <span className={cx('tab-icon')}>
                <VinIcon />
              </span>
            }
            Panel={
              <SearchByVin getArticlesIds={getArticlesIds} pageType={pageType} />
            }
          />
        )}
        <SearchAccordionItem
          uuid="reference"
          label={labels.searchReferenceTabTitle}
          Icon={
            <span className={cx('tab-icon')}>
              <ReferenceIcon />
            </span>
          }
          Panel={
            <SearchByRef
              pageType={pageType}
              setRefData={setRefData}
              setRefNoResults={setRefNoResults}
            />
          }
        />
      </Accordion>
    </div>
  );
};

SearchAccordion.propTypes = {
  selectedTabId: string.isRequired,
  pageType: oneOf(['home', 'search']).isRequired,
  setRefData: func.isRequired,
  setRefNoResults: func.isRequired,
  getArticlesIds: func.isRequired,
  resetSearchResults: func.isRequired,
  createTabChangeAction: func.isRequired,
  labels: object.isRequired,
};

export default withLabels(withRouter(SearchAccordion));



// WEBPACK FOOTER //
// ./src/components/SearchAccordion/SearchAccordion.js